export const tools = [
  {
    name: "qBittorrent",
    description: "开源免费的BT下载客户端，无广告、功能全面，支持磁力链接直接下载，是大多数用户的首选工具。",
    features: ["开源免费", "跨平台支持", "内置搜索引擎", "RSS订阅", "远程控制"],
    link: "#",
  },
  {
    name: "Transmission",
    description: "极致轻量的BT客户端，资源占用极低，非常适合NAS设备和服务器环境运行。",
    features: ["极简轻量", "Web界面", "命令行支持", "资源占用低", "稳定性高"],
    link: "#",
  },
  {
    name: "Deluge",
    description: "高度可定制的下载工具，丰富的插件系统让功能无限扩展，适合进阶用户。",
    features: ["插件丰富", "客户端-服务器架构", "Web界面", "标签管理", "自动化"],
    link: "#",
  },
  {
    name: "Aria2",
    description: "全能型命令行下载工具，支持HTTP/HTTPS/FTP/BT/磁力链接等多种协议，适合自动化场景。",
    features: ["命令行工具", "多协议支持", "资源占用极低", "远程控制", "脚本化"],
    link: "#",
  },
  {
    name: "BitComet",
    description: "老牌BT下载工具，支持长效种子技术，即使没有完整种子也能高速下载。",
    features: ["长效种子", "边下边播", "资源嗅探", "任务管理", "速度快"],
    link: "#",
  },
  {
    name: "Tixati",
    description: "专业级BT客户端，提供极其详细的网络连接统计和带宽管理功能，适合追求极致控制的用户。",
    features: ["详细统计", "带宽管理", "频道功能", "DHT详细视图", "无广告"],
    link: "#",
  },
];